const frmConstants = {
  dateField: {
    dateLabel: 'Preferred Date',
    placeholderText: 'Date'
  },
  nameField: {
    label: 'Name',
    placeholderText: 'John Doe'
  },
  mobileNumberField: {
    label: 'Mobile Number',
    placeholderText: '82933 32903'
  },
  mobileNumberOrEMailField: {
    label: 'Mobile Number/Email ID',
    placeholderText: 'Mobile Number/Email ID'
  },
  packageField: {
    dropDownValues: ['2 Overs', '3 Overs', 'Hourly Pack'],
    label: 'Package'
  },
  submitBtnText: 'BOOK NOW'
}

export const NO_OF_PEOPLE = 'no-of-people'
export const PREFERRED_DATE = 'preferred-date'
export const BOOK_NOW_BUTTON = 'book-now-button'
export const KOLKATA_BHOWANIPORE = 'kolkata-bhowanipore'

export default frmConstants



// WEBPACK FOOTER //
// ./src/components/FormHomePage/constants.js